import {parent_type,type} from '../variables/column_map';
export default class Type {

    static validate(column) {
        return type[column] ? parent_type[type[column]] : undefined;
    }

    static disp(column) {
        return type[column] ? parent_type[type[column]] : undefined;
    }
}